// extracted by mini-css-extract-plugin
module.exports = {"item":"CartSuccessPage_item__18CpP","section":"CartSuccessPage_section__3nB61"};